import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, Select } from '@iq/react-components';
import { setCuttingLines, setElementsInRow, setScanForPage } from '../../../../../bundles/qrCodes';
import SimpleModal from '../../../../SimpleModal';
import { getLayout } from '../../../../../bundles/layouts';

const elementsInRow = [
  { label: 'Extra Small (6 in line)', value: 6 },
  { label: 'Small (4 in line)', value: 4, default: true },
  { label: 'Medium (2 in line)', value: 2 },
  { label: 'Large (1 in line)', value: 1 },
];

const cuttingOptions = [
  { label: 'Shown', value: true, default: true },
  { label: 'Hidden', value: false },
];

const findDefault = (options) => options.find((option) => option?.default === true);

const QrModal = ({ siteId, onCloseModal }) => {
  const dispatch = useDispatch();
  const [pageOptions, setPageOptions] = useState([]);
  const layout = useSelector((state) => getLayout(state, siteId));

  useEffect(() => {
    const options = (layout?.pages || []).map((page, index) => ({
      label: page.title,
      value: page.pageIndex,
      pagePath: page.path,
      default: index === 0,
    }));
    setPageOptions(options);

    if (options.length > 0) {
      const defaultOption = findDefault(options);
      dispatch(setScanForPage(defaultOption.value, defaultOption.pagePath));
    }
  }, [dispatch, layout]);

  useEffect(() => {
    dispatch(setElementsInRow(findDefault(elementsInRow).value));
    dispatch(setCuttingLines(findDefault(cuttingOptions).value));
  }, [dispatch]);

  return (
    <SimpleModal
      className="generate-qr-code"
      title="Generate QR Codes"
      defautOnClose={onCloseModal}
    >
      <div className="body">
        {pageOptions.length > 0 && (
          <div className="select-row">
            <h3>Scan for page*</h3>
            <Select
              options={pageOptions}
              defaultValue={findDefault(pageOptions)}
              onChange={(event) => dispatch(setScanForPage(event.value, event.pagePath))}
            />
          </div>
        )}
        <div className="select-row">
          <h3>QR code size*</h3>
          <Select
            options={elementsInRow}
            defaultValue={findDefault(elementsInRow)}
            onChange={(event) => dispatch(setElementsInRow(event.value))}
          />
        </div>
        <div className="select-row">
          <h3>Cutting lines*</h3>
          <Select
            options={cuttingOptions}
            defaultValue={findDefault(cuttingOptions)}
            onChange={(event) => dispatch(setCuttingLines(event.value))}
          />
        </div>
      </div>
      <div className="actions">
        <Button
          activity="secondary"
          onClick={onCloseModal}
        >
          Cancel
        </Button>
        {pageOptions.length > 0 && (
          <Button className="redirect-button">
            <Link to={`/sites/${siteId}/admin/components/qr`}>Generate</Link>
          </Button>
        )}
      </div>
    </SimpleModal>
  );
};

export default QrModal;
